export default function getConfig() {
  let config;

  if (process.env.NODE_ENV === "development") {
    config = window["__APP_CONFIG__"] = {
      apiUrl: process.env.REACT_APP_API_BASE_URL ?? "",
      logoutUrl: process.env.REACT_APP_LOGOUT_URL ?? "",
      returnUrl: process.env.REACT_APP_RETURN_URL ?? "",
      ssoUrl: process.env.REACT_APP_SSO_URL ?? "",
      appInsightsKey: process.env.REACT_APP_APPINSIGHTS_KEY ?? "",
      appInsightsConnectionString:
        process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING ?? "",
      mode: "local",
      nonProductionMode: true,
    };
  } else {
    config = window["__APP_CONFIG__"];

    if (!config) {
      config = window["__APP_CONFIG__"] = {
        apiUrl: "",
        logoutUrl: "",
        ssoUrl: "",
        returnUrl: "",
        appInsightsKey: "",
        appInsightsConnectionString: "",
        mode: "",
        nonProductionMode: false,
      };
    }
  }

  return config;
}
